import { ArrowRight } from 'lucide-react'
import { Badge } from '@/components/ui/badge'
import LinkButton from '@/components/ui/link-button'
import { useTeam } from 'app/frontend/base/config/context/team'
import { useCustomDomain } from 'app/frontend/base/hooks/useCustomDomain'
import { useGameVersion } from 'app/frontend/base/hooks/useGameVersion'
import { useCandidates } from 'app/frontend/base/pages/GuildDashboard/subpages/GuildCandidates/hooks'

const CandidatesLink = () => {
  const { guild } = useTeam()
  const { data } = useCandidates()
  const approvedCount =
    data?.candidates.filter((candidate) => candidate.status === 'approved')
      .length ?? 0

  return (
    <LinkButton
      to={`${guild.path}/candidates`}
      variant='default'
      size='sm'
      className='gap-2'
    >
      Go to candidates
      <Badge variant='secondary'>{approvedCount}</Badge>
      <ArrowRight size={14} />
    </LinkButton>
  )
}

const CandidatesButton = () => {
  const gameVersion = useGameVersion()
  const { customDomain } = useCustomDomain()

  if (!gameVersion.has('guild_candidates') || customDomain?.team) return null

  return <CandidatesLink />
}

export default CandidatesButton
